import React from 'react'
import { IconSVGType } from '../../../types/icons'

export const AmexCardWhiteIcon = (props: IconSVGType) => {
  return (
    <svg
      width='67'
      height='18'
      viewBox='0 0 67 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_651_4709)'>
        <path
          d='M38.2589 7.8756H39.2999H40.36V3.95215V0H39.3095H38.2589V3.93301V7.8756Z'
          fill='white'
        />
        <path
          d='M34.1044 3.37799H31.9079V1.78947H34.1044C34.7348 1.78947 35.0499 2.16268 35.0499 2.58373C35.0499 3.02392 34.7348 3.37799 34.1044 3.37799ZM37.1606 2.54545C37.1606 1.04306 36.0814 0 34.3528 0H29.8068V7.8756H31.9079V5.11962H32.6719L35.0595 7.8756H37.6667L35.0595 5.03349C36.3679 4.74641 37.1606 3.7799 37.1606 2.54545Z'
          fill='white'
        />
        <path
          d='M43.569 4V3.85646C43.569 2.689 44.2184 1.84689 45.565 1.84689H47.8953V0H45.3836C42.7954 0 41.4679 1.66507 41.4679 3.85646V4.00957C41.4679 6.44976 42.9673 7.86603 45.2881 7.86603H46.0043L46.8448 6.07655H45.6128C44.3521 6.08612 43.569 5.37799 43.569 4Z'
          fill='white'
        />
        <path
          d='M3.69601 4.54545L4.7943 1.91388L5.8926 4.54545H3.69601ZM3.4668 0L0 7.8756H2.3112L2.97018 6.27751H6.60888L7.27741 7.8756H9.64591L6.17911 0H3.4668Z'
          fill='white'
        />
        <path
          d='M15.1374 4.95694L13.3419 0H10.047V7.8756H12.1099V2.20096L14.1823 7.8756H16.0447L18.1266 2.20096V7.8756H20.1895V0H16.9233L15.1374 4.95694Z'
          fill='white'
        />
        <path
          d='M21.7941 7.8756H28.4316V6.08612H23.8952V4.82297H28.3265V3.03349H23.8952V1.78947H28.4316V0H21.7941V7.8756Z'
          fill='white'
        />
        <path
          d='M50.6648 4.54545L51.7727 1.91388L52.871 4.54545H50.6648ZM50.4452 0L46.9784 7.8756H49.2896L49.9486 6.27751H53.5873L54.2558 7.8756H56.6243L53.1575 0H50.4452Z'
          fill='white'
        />
        <path
          d='M62.8703 4.80383L59.6709 0H57.0159V7.8756H59.1074V2.88995L62.4023 7.8756H64.9427V0H62.8703V4.80383Z'
          fill='white'
        />
        <path
          d='M55.9558 13.1675H54.0266C53.6159 13.1675 53.3103 12.9187 53.3103 12.5359C53.3103 12.1627 53.6159 11.9139 54.0266 11.9139H57.5125L58.3338 10.1244H54.017C52.2311 10.1244 51.2092 11.177 51.2092 12.6029C51.2092 14.0861 52.1929 14.9569 53.7305 14.9569H55.6597C56.0895 14.9569 56.376 15.2057 56.376 15.5885C56.376 15.9713 56.0799 16.2201 55.6597 16.2201H51.448V18.0096H55.6788C57.4361 18.0096 58.4866 16.9761 58.4866 15.4545C58.4866 14.0096 57.5602 13.1675 55.9558 13.1675Z'
          fill='white'
        />
        <path
          d='M39.5386 13.5024H37.3421V11.9139H39.5386C40.169 11.9139 40.4841 12.2871 40.4841 12.7081C40.4746 13.1483 40.1594 13.5024 39.5386 13.5024ZM42.5852 12.6699C42.5852 11.1675 41.506 10.1244 39.7774 10.1244H35.241V17.9904H37.3421V15.2344H38.1061L40.4937 17.9904H43.1009L40.4937 15.1483C41.8021 14.8708 42.5852 13.9043 42.5852 12.6699Z'
          fill='white'
        />
        <path
          d='M43.6836 18H50.3307V16.2105H45.7847V14.9474H50.2161V13.1675H45.7847V11.9139H50.3307V10.1244H43.6836V18Z'
          fill='white'
        />
        <path
          d='M31.2871 13.6459H29.0332V11.9139H31.2871C31.9174 11.9139 32.2326 12.3062 32.2326 12.7943C32.2326 13.2632 31.9174 13.6459 31.2871 13.6459ZM31.5354 10.1244H26.9321V18H29.0332V15.4354H31.4686C33.2449 15.4354 34.3432 14.3062 34.3432 12.7847C34.3432 11.2057 33.264 10.1244 31.5354 10.1244Z'
          fill='white'
        />
        <path
          d='M63.6726 13.1675H61.7434C61.3327 13.1675 61.0271 12.9187 61.0271 12.5359C61.0271 12.1627 61.3327 11.9139 61.7434 11.9139H65.2293L66.0506 10.1244H61.7338C59.9479 10.1244 58.926 11.177 58.926 12.6029C58.926 14.0861 59.9097 14.9569 61.4473 14.9569H63.3765C63.8063 14.9569 64.0928 15.2057 64.0928 15.5885C64.0928 15.9713 63.7967 16.2201 63.3765 16.2201H59.1648V18.0096H63.3861C65.1433 18.0096 66.1939 16.9761 66.1939 15.4545C66.2034 14.0096 65.277 13.1675 63.6726 13.1675Z'
          fill='white'
        />
        <path
          d='M10.047 18H16.6845V16.2105H12.1385V14.9474H16.5699V13.1675H12.1385V11.9139H16.6845V10.1244H10.047V18Z'
          fill='white'
        />
        <path
          d='M26.5501 10.1244H23.876L21.8417 12.4976L19.7979 10.1244H17.057L20.5142 14.0191L16.9901 18H19.6642L21.8035 15.5024L23.9428 18H26.6838L23.1406 13.9713L26.5501 10.1244Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_651_4709'>
          <rect width='66.2034' height='18' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
